(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/invitation-signup/:invitationToken', {
      templateUrl: 'modules/outside/invitation-signup/invitation-signup.html',
      controller: 'InvitationSignUpCtrl'
    });
  }]).controller('InvitationSignUpCtrl', ['$scope', '$http', 'Config', 'Validation', 'Utils', 'User', 'Logger', '$routeParams', 'Api', 'OrganizationSettings', function ($scope, $http, Config, Validation, Utils, User, Logger, $routeParams, Api, OrganizationSettings) {
    var wsConfig = Config.get();
    function validateForm($scope) {
      return Validation.validate({
        "password": {
          "rules": {
            "required": true,
            "password": true
          },
          "value": $scope.invitationFulfillmentData.password
        },
        "passwordConfirm": {
          "rules": {
            "required": true,
            "matches": "password"
          },
          "display": "Confirm password",
          "value": $scope.invitationFulfillmentData.passwordConfirm
        }
      });
    }
    $scope.signup = function signup() {
      $scope.signupError = null;
      if (!externalLoginToken) {
        $scope.formErrors = validateForm($scope);
        if ($scope.formErrors !== null) {
          return;
        }
      }
      $http.post(Api.url("/invitations", true), $scope.invitationFulfillmentData).then(function createUserSuccess() {
        if (externalLoginToken) {
          $scope.tryLoginWithAuth("Bearer " + externalLoginToken);
        } else {
          $scope.tryLogin($scope.invitation.email, $scope.invitationFulfillmentData.password);
        }
      }, function createUserError(response) {
        $scope.signupError = "There was an error accepting your invitation: ";
        if (response.status === 409) {
          $scope.signupError += "A user with the given email already exists.";
        } else if (response.data.message) {
          $scope.signupError += response.data.message;
        }
      });
    };
    var invitationToken = $routeParams.invitationToken,
      externalLoginToken = Utils.getQueryVariable("token"),
      externalLoginError = Utils.getQueryVariable("error");

    // Setup some scope state
    $scope.invitation = {};
    $scope.invitationFulfillmentData = {};
    $scope.formErrors = null;
    $scope.showForm = externalLoginToken === undefined;
    $scope.googleLoginEnabled = false;

    // Fetch the invitation so we can verify it's a good token and pre-populate the form.
    $http.get(Api.url("/invitations/" + invitationToken)).then(function fetchInvitationSuccess(response) {
      $scope.invitation = response.data;
      $scope.invitationFulfillmentData.id = $scope.invitation.id;

      // If we hit some error via external login, show it and stop.
      if (externalLoginError) {
        $scope.externalLoginError = "There was an error logging in from the external system: " + externalLoginError;
        return;
      }

      // If we've come to this page after going through an external login (Google login),
      // fetch some user information and override the info in the invitation with that
      if (externalLoginToken) {
        var requestConfig = {
          headers: {
            "Authorization": "Bearer " + externalLoginToken
          }
        };
        $http.post(wsConfig.apiUrl + "/login", null, requestConfig).then(function loginSuccess(response) {
          var user = response.data.user;
          $scope.invitationFulfillmentData.name = user.name;
          $scope.invitationFulfillmentData.email = user.email;
          $scope.invitationFulfillmentData.username = user.username;
          $scope.signup(true);
        }, function loginFailure() {
          $scope.signupError = "There was an error accepting your invitation.";
        });
      }

      // If google login enabled on the system, make sure it's not disabled by the org.
      if (wsConfig.googleLoginEnabled === true) {
        var orgId = $scope.invitation.organization.id;

        // We disable google login if the org has an explicit id
        // provider list and google is not one of them. Otherwise, enable it.
        OrganizationSettings.getForOrganization(orgId).then(function (response) {
          var idp = response.identityProviders;
          $scope.googleLoginEnabled = _.isEmpty(idp) || _.contains(idp, "google");
        });
      }
    }, function fetchInvitationError(response) {
      if (response.status === 404) {
        // We're inferring that a 404 non-found means the invitation has been fulfilled because
        // it's deleted after fulfillment
        $scope.sendToApp();
      } else {
        Logger.error("Invitation fetch failed with response status " + response.status);
        $scope.error = "There was an error fetching your invitation.";
      }
    });
  }]);
})();
